import { render, staticRenderFns } from "./TopicFormPanelGeneralFields.vue?vue&type=template&id=beb025e0"
import script from "./TopicFormPanelGeneralFields.vue?vue&type=script&lang=ts"
export * from "./TopicFormPanelGeneralFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports